import { Component } from '@angular/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsyncPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { selectDarkMode } from '../../store/selector/theme.selector';
import { setDarkMode } from '../../store/action/theme.action';
import { ThemeState } from '../../store/model/theme.model';
import { ThemeInitializerService } from '../../utils/theme-initializer.service';
import { SidebarComponent } from "../sidebar/sidebar.component";
import { AuthState } from '../../auth/store/auth.model';
import { selectUser } from '../../auth/store/auth.selector';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterModule, CommonModule, SidebarComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {

  profileUrl = 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
  isDarkMode$: Observable<ThemeState['darkMode']>;
  user$: Observable<AuthState['user']>;

  constructor(private store: Store, private themeService: ThemeInitializerService,private authService:AuthService) {
    this.isDarkMode$ = this.store.select(selectDarkMode);
    this.user$ = this.store.select(selectUser); // this line was missing in your code
  }

   toggleDarkMode() {
    this.isDarkMode$.pipe(take(1)).subscribe((darkMode) => {
      this.themeService.updateTheme({ darkMode: !darkMode });
      if(darkMode){
        document.documentElement.dataset['theme'] = 'dark';
      }else{
        document.documentElement.dataset['theme'] = 'light';
      }


    });
  }

  logout(){
    this.authService.logout();
  }

}
